import { useState, useEffect } from 'react'

const MEDIA_MD = '(min-width: 768px)'

/**
 * Returns true when viewport is at least 768px (Tailwind md breakpoint).
 * Updates on resize so components can branch desktop vs mobile behavior.
 */
export function useMediaQuery(query: string = MEDIA_MD): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    const mql = window.matchMedia(query)
    setMatches(mql.matches)
    const handler = (e: MediaQueryListEvent): void => setMatches(e.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [query])

  return matches
}

/** True when viewport is md or larger (desktop). */
export function useIsDesktop(): boolean {
  return useMediaQuery(MEDIA_MD)
}
